import axiosInstance from '../utils/axiosInstance';
import { absoluteApiUrl } from './drive';

const data = (p) => p.then((r) => r.data);

const syncApi = {
  linkInfo: (code) => data(axiosInstance.get(`api/sync/device/link/${encodeURIComponent(code)}/`)),
  approve: (code, approve) => data(axiosInstance.post(`api/sync/device/link/${encodeURIComponent(code)}/`, { approve })),
  devices: () => data(axiosInstance.get('api/sync/devices/')),
  revoke: (id) => axiosInstance.delete(`api/sync/devices/${id}/`),
  downloads: () => data(axiosInstance.get('api/sync/downloads/')),
  downloadUrl: async (platform) => {
    const { url } = await data(axiosInstance.post(`api/sync/downloads/${platform}/link/`));
    return absoluteApiUrl(url);
  },
  publish: (platform, file, version, onProgress) => {
    const form = new FormData();
    form.append('platform', platform);
    if (version) form.append('version', version);
    form.append('file', file);
    return data(axiosInstance.post('api/sync/downloads/', form, {
      onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0),
    }));
  },
};

export default syncApi;
